import { render, staticRenderFns } from "./actMaleRules.vue?vue&type=template&id=7f23820a&scoped=true"
import script from "./actMaleRules.vue?vue&type=script&lang=js"
export * from "./actMaleRules.vue?vue&type=script&lang=js"
import style0 from "./actMaleRules.vue?vue&type=style&index=0&id=7f23820a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f23820a",
  null
  
)

export default component.exports